import React, { useContext, useRef, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Image,
  ScrollView,
  Platform,
  Dimensions,
} from "react-native";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
import AsyncStorage from "@react-native-community/async-storage";
import AppContext from "../context";
import Icon from "react-native-vector-icons/Ionicons";
import { useNavigation, useFocusEffect } from "@react-navigation/native";
import { View as DView } from "dripsy";
import FinalAnimation from "../components/FinalAnimation";
// import { captureRef } from 'react-native-view-shot-with-web-support';
// import Share from "react-native-share";
import RewardRules from "../components/RewardRules";
import { Confirm } from "../util/Alert";

export default function Stats() {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { tour, setTour, setGameMenuHeight, dict } = useContext(AppContext);
  const navigation = useNavigation();
  const menuHeight = useRef(500);
  const cap = useRef();
  const [captureText, setCaptureText] = useState("");
  const [captureTextTop, setCaptureTextTop] = useState("");

  useFocusEffect(() => {
    setGameMenuHeight(
      Math.min(menuHeight.current, Dimensions.get("window").height - 110)
    );
  });

  const resetTour = () => {
    Confirm(dict.are_you_sure_reset_tour, "", dict.cancel, dict.ok).then(
      async () => {
        await AsyncStorage.removeItem("progress-" + tour.encryptTourID);
        window.location.reload();
        // AsyncStorage.getItem("raw-" + tour.encryptTourID).then((d) => {
        //   setTour(JSON.parse(d));

        //   // console.log(JSON.parse(d));
        // });
      }
    );
  };

  const shareFinalScore = () => {
    setCaptureText("https://www.guidigo.com/" + tour.encryptTourID);
    setCaptureTextTop(dict.share_text_1 + tour.name + dict.share_text_2);
    // setTimeout(() => {
    //   captureRef(cap, {
    //     format: "jpg",
    //     quality: 0.8,
    //   }).then(
    //     (url) => {
    //       console.log("Image saved to", url);
    //       setCaptureText("");
    //       setCaptureTextTop("");
    //       Share.open({
    //         url,
    //         message:
    //           dict.share_text_1 +
    //           tour.name +
    //           dict.share_text_3 +
    //           "https://www.guidigo.com/" +
    //           tour.encryptTourID,
    //         title: "https://www.guidigo.com/" + tour.encryptTourID,
    //       });
    //     },
    //     (error) => console.error("Oops, snapshot failed", error)
    //   );
    // }, 100);
  };

  return (
    <ScrollView
      style={{
        padding: 20,
        borderRadius: 10,
      }}
    >
      <View
        onLayout={(e) => {
          // console.log(e.nativeEvent.layout.height);
          menuHeight.current = e.nativeEvent.layout.height;
          setGameMenuHeight(menuHeight.current);
        }}
      >
        <Text
          style={{
            color: colors[theme].text,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 18,
          }}
        >
          {dict.treasure_hunt}
        </Text>
        <TouchableOpacity
          style={{
            borderWidth: 2,
            borderColor: colors[theme].buttonBorder,
            paddingVertical: 5,
            paddingHorizontal: 12,
            position: "absolute",
            left: 0,
            top: -4,
            borderRadius: 4,
          }}
          onPress={() => resetTour()}
        >
          <Text
            style={{
              color: colors[theme].text,
              textAlign: "center",
            }}
          >
            {dict.reset}
          </Text>
        </TouchableOpacity>
        <View
          style={{
            backgroundColor: colors[theme].gameButtonBg,
            borderRadius: 10,
            padding: 20,
            shadowColor: "#000",
            shadowOffset: {
              width: 0,
              height: 0,
            },
            shadowOpacity: 0.1,
            shadowRadius: 6.27,
            elevation: 6,
            marginTop: 30,
          }}
          ref={cap}
        >
          {tour.totalChallenges === tour.challengesWon + tour.challengesLost ? (
            <FinalAnimation
              inStats={true}
              share={shareFinalScore}
              captureText={captureText}
              captureTextTop={captureTextTop}
            />
          ) : (
            <>
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 64,
                  fontWeight: "bold",
                  color: "#26C97A",
                }}
              >
                {tour.totalScore}
              </Text>
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 19,
                  fontWeight: "500",
                  color: colors[theme].text,
                }}
              >
                {dict.points_earned_so_far}
              </Text>
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 14,
                  fontWeight: "500",
                  color: colors[theme].text,
                  opacity: 0.4,
                  marginTop: 5,
                }}
              >
                (
                {tour.totalChallenges -
                  tour.challengesWon -
                  tour.challengesLost}{" "}
                {dict.challenges_left})
              </Text>
            </>
          )}
        </View>
        {tour.totalChallenges === tour.challengesWon + tour.challengesLost ? (
          <RewardRules rules={tour.rewardRules} />
        ) : null}
        <View
          style={{
            flexWrap: "wrap",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <DView
            sx={
              Platform.OS === "web" ? null : { width: ["100%", "49%", "100%"] }
            }
            style={{ width: "100%" }}
          >
            <TouchableOpacity
              style={[
                styles.button,
                {
                  backgroundColor: colors[theme].gameButtonBg,
                },
              ]}
              onPress={() => navigation.navigate("Progress")}
            >
              <View style={{ flexDirection: "row" }}>
                {theme === "dark" ? (
                  <Image
                    source={require("../assets/progress-white.png")}
                    style={{ width: 26, height: 26 }}
                  />
                ) : (
                  <Image
                    source={require("../assets/progress.png")}
                    style={{ width: 26, height: 26 }}
                  />
                )}
                <Text
                  style={[styles.buttonText, { color: colors[theme].text }]}
                >
                  {dict.progress}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Text style={[styles.num, { color: colors[theme].text }]}>
                  {tour.challengesLost + tour.challengesWon}/
                  {tour.totalChallenges}
                </Text>
                <Icon
                  name="chevron-forward"
                  size={16}
                  color={colors[theme].text}
                />
              </View>
            </TouchableOpacity>
          </DView>
          {tour.totalInventory ? (
            <DView
              sx={
                Platform.OS === "web"
                  ? null
                  : { width: ["100%", "49%", "100%"] }
              }
              style={{ width: "100%" }}
            >
              <TouchableOpacity
                style={[
                  styles.button,
                  { backgroundColor: colors[theme].gameButtonBg },
                ]}
                onPress={() =>
                  navigation.navigate("Inventory", { type: "inventory" })
                }
              >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  {theme === "dark" ? (
                    <Image
                      source={require("../assets/inventory-white.png")}
                      style={{ width: 26, height: 24 }}
                    />
                  ) : (
                    <Image
                      source={require("../assets/inventory.png")}
                      style={{ width: 26, height: 24 }}
                    />
                  )}
                  <Text
                    style={[styles.buttonText, { color: colors[theme].text }]}
                  >
                    {dict.inventory}
                  </Text>
                  {tour.badgeInventory ? (
                    <View style={styles.badge}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontWeight: "bold",
                          color: "#FFF",
                        }}
                      >
                        {tour.badgeInventory}
                      </Text>
                    </View>
                  ) : null}
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Text style={[styles.num, { color: colors[theme].text }]}>
                    {tour.inventory.length}/{tour.totalInventory}
                  </Text>
                  <Icon
                    name="chevron-forward"
                    size={16}
                    color={colors[theme].text}
                  />
                </View>
              </TouchableOpacity>
            </DView>
          ) : null}
          {tour.totalArtifacts ? (
            <DView
              sx={
                Platform.OS === "web"
                  ? null
                  : { width: ["100%", "49%", "100%"] }
              }
              style={{ width: "100%" }}
            >
              <TouchableOpacity
                style={[
                  styles.button,
                  { backgroundColor: colors[theme].gameButtonBg },
                ]}
                onPress={() => navigation.navigate("Album")}
              >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  {theme === "dark" ? (
                    <Image
                      source={require("../assets/album-white.png")}
                      style={{ width: 28, height: 21 }}
                    />
                  ) : (
                    <Image
                      source={require("../assets/album.png")}
                      style={{ width: 28, height: 21 }}
                    />
                  )}
                  <Text
                    style={[styles.buttonText, { color: colors[theme].text }]}
                  >
                    {dict.photo_album}
                  </Text>
                  {tour.badgeAlbum ? (
                    <View style={styles.badge}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontWeight: "bold",
                          color: "#FFF",
                        }}
                      >
                        {tour.badgeAlbum}
                      </Text>
                    </View>
                  ) : null}
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Text style={[styles.num, { color: colors[theme].text }]}>
                    {tour.album.length}/{tour.totalArtifacts}
                  </Text>
                  <Icon
                    name="chevron-forward"
                    size={16}
                    color={colors[theme].text}
                  />
                </View>
              </TouchableOpacity>
            </DView>
          ) : null}
          {tour.totalPuzzles ? (
            <DView
              sx={
                Platform.OS === "web"
                  ? null
                  : { width: ["100%", "49%", "100%"] }
              }
              style={{ width: "100%" }}
            >
              <TouchableOpacity
                style={[
                  styles.button,
                  { backgroundColor: colors[theme].gameButtonBg },
                ]}
                onPress={() => navigation.navigate("JigsawPuzzle")}
              >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  {theme === "dark" ? (
                    <Image
                      source={require("../assets/puzzle-piece-white.png")}
                      style={{ width: 24, height: 24 }}
                    />
                  ) : (
                    <Image
                      source={require("../assets/puzzle-piece.png")}
                      style={{ width: 24, height: 24 }}
                    />
                  )}
                  <Text
                    style={[styles.buttonText, { color: colors[theme].text }]}
                  >
                    {dict.jigsaw_puzzle}
                  </Text>
                  {tour.badgePuzzle ? (
                    <View style={styles.badge}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontWeight: "bold",
                          color: "#FFF",
                        }}
                      >
                        {tour.badgePuzzle}
                      </Text>
                    </View>
                  ) : null}
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Text style={[styles.num, { color: colors[theme].text }]}>
                    {tour.puzzles.filter((v) => v.objectName !== "?").length}/
                    {tour.totalPuzzles}
                  </Text>
                  <Icon
                    name="chevron-forward"
                    size={16}
                    color={colors[theme].text}
                  />
                </View>
              </TouchableOpacity>
            </DView>
          ) : null}
          {tour.totalLetters ? (
            <DView
              sx={
                Platform.OS === "web"
                  ? null
                  : { width: ["100%", "49%", "100%"] }
              }
              style={{ width: "100%" }}
            >
              <TouchableOpacity
                style={[
                  styles.button,
                  { backgroundColor: colors[theme].gameButtonBg },
                ]}
                onPress={() => navigation.navigate("MysteryWord")}
              >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  {theme === "dark" ? (
                    <Image
                      source={require("../assets/mystery-white.png")}
                      style={{ width: 26, height: 24 }}
                    />
                  ) : (
                    <Image
                      source={require("../assets/mystery.png")}
                      style={{ width: 24, height: 24 }}
                    />
                  )}
                  <Text
                    style={[styles.buttonText, { color: colors[theme].text }]}
                  >
                    {dict.mystery_word}
                  </Text>
                  {tour.badgeLetter ? (
                    <View style={styles.badge}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontWeight: "bold",
                          color: "#FFF",
                        }}
                      >
                        {tour.badgeLetter}
                      </Text>
                    </View>
                  ) : null}
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Text style={[styles.num, { color: colors[theme].text }]}>
                    {tour.letters.filter((v) => v.objectName !== "?").length}/
                    {tour.totalLetters}
                  </Text>
                  <Icon
                    name="chevron-forward"
                    size={16}
                    color={colors[theme].text}
                  />
                </View>
              </TouchableOpacity>
            </DView>
          ) : null}
        </View>
        <View style={{ height: 50 }} />
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  button: {
    borderRadius: 10,
    padding: 16,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 6.27,
    elevation: 4,
    marginTop: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  buttonText: {
    fontSize: 18,
    fontWeight: "600",
    opacity: 0.7,
    marginLeft: 12,
  },
  num: {
    fontSize: 12,
    opacity: 0.5,
    marginRight: 10,
  },
  badge: {
    backgroundColor: "#F49345",
    width: 18,
    height: 18,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 10,
  },
});
